var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUndo = function SvgUndo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6C6C89",
    fillRule: "evenodd",
    d: "M6.53 2.804a.75.75 0 0 1 0 1.06L5.144 5.251H12a6.083 6.083 0 0 1 0 12.166H6.667a.75.75 0 0 1 0-1.5H12a4.583 4.583 0 1 0 0-9.166H5.144L6.53 8.137a.75.75 0 0 1-1.06 1.06L2.803 6.532a.75.75 0 0 1 0-1.06L5.47 2.803a.75.75 0 0 1 1.06 0",
    clipRule: "evenodd"
  })));
};
export default SvgUndo;